export default "__VITE_ASSET__Det3T_70__"